import { string as sanitizeString } from 'olapic-js-utils/browser/sanitize';

const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/accounts/:id?', {
    template: ({ id = '' }) => `
      <brands-container selected-id="${sanitizeString(id)}"></brands-container>
    `,
  });
};

export default routeProviderConfig;
